/* Mobile navigation — Option A "push panels" (dansonsmedical.com)
   Works with snippets/mobile-menu.liquid and assets/mobile-menu.css. Plain JS, no jQuery.

   - ☰ (#show_mobile_menu) opens the full-screen sheet: the page is frozen where it is, focus moves
     to the close button, and exactly ONE history entry is pushed so the phone's back button closes it.
   - A category row slides its level-2 panel in (250 ms). Back, ✕, Escape, a right-swipe or the
     phone's back button return to level 1. Panel changes rewrite that one entry, they never add more.
   - Tapping a link inside the menu drops the menu's entry before navigating, so Back from the
     destination lands on the page the menu was opened from, not on a ghost copy of it.
   - Pinned bars and sticky group headers get a shadow while something is scrolled under them.
   - Every listener is delegated to document, so the theme editor can re-render the section freely.
   - Only meaningful at <= 768px; the sheet closes itself if the viewport grows past that. */
(function () {
  'use strict';
  if (window.__dansonsMobileMenu) { return; } // the section's <script> can run again in the theme editor
  window.__dansonsMobileMenu = true;

  var html = document.documentElement;
  var mql = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var canPush = !!(window.history && window.history.pushState);

  var isOpen = false;
  var openPanelId = null;   // id of the level-2 panel currently shown
  var pushed = false;       // the menu's single history entry exists
  var savedScroll = 0;
  var lastFocus = null;
  var pendingHref = null;   // link tapped inside the menu, navigated to once the entry is dropped
  var pendingTimer = null;
  var unmountTimer = null;
  var pendingBack = false;  // we called history.back() to drop our entry and its popstate has not arrived
  var pendingBackTimer = null;
  var restoredAt = 0;       // when unlock() last restored the scroll position

  function sheet() { return document.getElementById('mm-sheet'); }
  function burger() { return document.getElementById('show_mobile_menu'); }
  function root() { var s = sheet(); return s ? s.querySelector('.mm-panel--root') : null; }
  function panel() { return openPanelId ? document.getElementById(openPanelId) : null; }

  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') { return; }
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches(selector)) { return el; }
      el = el.parentNode;
    }
    return null;
  }

  /* ---- history: one entry for the sheet, rewritten as panels open and close ---------------- */
  function setState(level) { // 1 = sheet, 2 = sheet + panel
    if (!canPush) { return; }
    try {
      if (pushed) { window.history.replaceState({ mm: level }, ''); }
      else { window.history.pushState({ mm: level }, ''); pushed = true; }
    } catch (e) { /* history unavailable */ }
  }

  function scrollRestoration(mode) {
    try { if ('scrollRestoration' in window.history) { window.history.scrollRestoration = mode; } } catch (e) { /* ignore */ }
  }

  function keepScroll(y) { // apply now and again next frame: Safari restores after popstate
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    window.requestAnimationFrame(function () { window.scrollTo(0, y); html.style.scrollBehavior = prev; });
  }

  function dropState() { // step back over the menu's entry; the popstate is ours and is handled as such
    if (!pushed) { return; }
    pushed = false;
    pendingBack = true;
    clearTimeout(pendingBackTimer);
    pendingBackTimer = setTimeout(function () { pendingBack = false; scrollRestoration('auto'); }, 1500);
    scrollRestoration('manual'); // the browser must not scroll the page for our own traversal
    try { window.history.back(); } catch (e) { pendingBack = false; scrollRestoration('auto'); }
  }

  /* ---- scroll lock: freeze the page where it is (also works on older iOS) ------------------- */
  function lock() {
    var y = window.pageYOffset || html.scrollTop || 0;
    // reopened within a few hundred ms of closing: the browser may not have applied the restore yet
    if (y === 0 && savedScroll > 0 && Date.now() - restoredAt < 400) { y = savedScroll; }
    savedScroll = y;
    document.body.style.top = -savedScroll + 'px';
    html.classList.add('mm-lock');
  }

  function unlock() {
    if (!html.classList.contains('mm-lock')) { return; }
    html.classList.remove('mm-lock');
    document.body.style.top = '';
    void document.body.offsetHeight; // apply the layout change before restoring the position
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, savedScroll);
    html.style.scrollBehavior = prev;
    restoredAt = Date.now();
  }

  /* ---- sticky shadows ------------------------------------------------------------------------ */
  function updateStuck(p) {
    if (!p) { return; }
    var bar = p.querySelector('.mm-bar');
    if (!bar) { return; }
    var scrolled = p.scrollTop > 0;
    bar.classList.toggle('is-stuck', scrolled);
    var barBottom = bar.getBoundingClientRect().bottom;
    var heads = p.querySelectorAll('.mm-group:not(.mm-group--single) > .mm-group__head');
    for (var i = 0; i < heads.length; i++) {
      var head = heads[i];
      var r = head.getBoundingClientRect();
      var groupBottom = head.parentNode.getBoundingClientRect().bottom;
      head.classList.toggle('is-stuck', scrolled && r.top <= barBottom + 1 && groupBottom > barBottom + 1);
    }
  }

  /* ---- level-2 panels --------------------------------------------------------------------------- */
  function setOpener(id, expanded) {
    var s = sheet();
    var a = s ? s.querySelector('[data-mm-open="' + id + '"]') : null;
    if (a) { a.setAttribute('aria-expanded', expanded ? 'true' : 'false'); }
  }

  function loadImages(p) { // tiles are lazy while their panel is off-screen; fetch them as it opens
    var imgs = p.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) { imgs[i].loading = 'eager'; }
  }

  function showPanel(p) {
    if (!p || p.id === openPanelId) { return; }
    var prev = panel();
    if (prev) { hidePanelDom(prev); }
    openPanelId = p.id;
    loadImages(p);
    p.scrollTop = 0;
    p.classList.add('is-open');
    p.setAttribute('aria-hidden', 'false');
    var r = root();
    if (r) { r.setAttribute('aria-hidden', 'true'); }
    setOpener(p.id, true);
    if (isOpen) { setState(2); }
    updateStuck(p);
    focusEl(p.querySelector('.mm-title'));
  }

  function hidePanelDom(p) {
    p.classList.remove('is-open');
    p.setAttribute('aria-hidden', 'true');
    setOpener(p.id, false);
    if (openPanelId === p.id) { openPanelId = null; }
    var r = root();
    if (r) { r.setAttribute('aria-hidden', 'false'); }
  }

  function backToRoot() {
    var p = panel();
    if (!p) { return; }
    hidePanelDom(p);
    if (isOpen) { setState(1); }
    var s = sheet();
    focusEl(s ? s.querySelector('[data-mm-open="' + p.id + '"]') : null);
  }

  /* ---- the sheet -------------------------------------------------------------------------------- */
  function openSheet() {
    var s = sheet();
    if (!s || isOpen) { return; }
    if (mql && !mql.matches) { return; } // the sheet only exists at <= 768px
    isOpen = true;
    clearTimeout(unmountTimer);
    lastFocus = document.activeElement;
    // Push the entry BEFORE locking: the browser records the page's scroll position on the entry
    // it leaves, and restores it when we step back. If our previous back-traversal is still in
    // flight, its popstate will re-arm the entry instead.
    if (pendingBack) { pushed = false; } else { setState(1); }
    lock();
    s.classList.add('is-mounted');
    void s.offsetWidth; // commit display:block before the slide starts
    s.classList.add('is-open');
    var r = root();
    if (r) { r.scrollTop = 0; r.setAttribute('aria-hidden', 'false'); }
    var b = burger();
    if (b) { b.setAttribute('aria-expanded', 'true'); }
    updateStuck(r);
    focusEl(s.querySelector('.mm-panel--root .mm-close'));
  }

  function closeDom() { // close the UI; the caller decides what happens to the history entry
    if (!isOpen) { return; }
    isOpen = false;
    var s = sheet();
    var b = burger();
    var p = panel();
    if (p) { hidePanelDom(p); }
    if (s) {
      s.classList.remove('is-open');
      clearTimeout(unmountTimer);
      unmountTimer = setTimeout(function () { if (!isOpen) { s.classList.remove('is-mounted'); } }, reduceMotion ? 0 : 220);
    }
    if (b) { b.setAttribute('aria-expanded', 'false'); }
    unlock();
    focusEl(lastFocus && lastFocus !== document.body && document.contains(lastFocus) ? lastFocus : b);
    lastFocus = null;
  }

  function closeSheet() { // the user closed it: ✕, Escape, viewport change
    if (!isOpen) { return; }
    closeDom();
    dropState();
  }

  /* ---- links inside the menu: drop the entry first, then navigate ---------------------------------- */
  function followLink(a, e) {
    if (!pushed || !canPush) { return; }
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
    if (a.target && a.target !== '_self') { return; }
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^(javascript|mailto|tel):/i.test(href)) { return; }
    e.preventDefault();
    pendingHref = a.href;
    pushed = false;
    try { window.history.back(); } catch (err) { pendingHref = null; window.location.assign(a.href); return; }
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () { // popstate never came: go anyway
      if (pendingHref) { var h = pendingHref; pendingHref = null; window.location.assign(h); }
    }, 400);
  }

  /* ---- popstate: the phone's back button --------------------------------------------------------- */
  window.addEventListener('popstate', function (e) {
    if (pendingHref) {
      var h = pendingHref;
      pendingHref = null;
      clearTimeout(pendingTimer);
      window.location.assign(h);
      return;
    }
    if (pendingBack) { // the traversal we requested when closing; the sheet may have been reopened since
      pendingBack = false;
      clearTimeout(pendingBackTimer);
      scrollRestoration('auto');
      pushed = false;
      if (isOpen) { setState(panel() ? 2 : 1); } // re-arm: push a fresh entry on top of the page's own
      else if (savedScroll > 0 && Date.now() - restoredAt < 2500) { keepScroll(savedScroll); } // hold the position
      return;
    }
    var level = (e.state && e.state.mm) ? e.state.mm : 0;
    if (!isOpen) { pushed = false; return; }
    if (level === 0) {
      pushed = false;
      if (panel()) { backToRoot(); } // back from level 2: level 1, and re-arm the entry (setState pushes again)
      else { closeDom(); }
    } else if (level === 1 && panel()) {
      pushed = true;
      backToRoot();
    }
  });

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) { return; }
    pendingHref = null;
    clearTimeout(pendingTimer);
    closeDom(); // restored from the back-forward cache: never come back with the sheet open
    pushed = false;
  });

  /* ---- clicks ---------------------------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    if (closest(e.target, '#show_mobile_menu')) {
      e.preventDefault();
      if (isOpen) { closeSheet(); } else { openSheet(); }
      return;
    }
    var s = sheet();
    if (!s || !s.contains(e.target)) { return; }
    var t = closest(e.target, '[data-mm-open], [data-mm-back], [data-mm-close], a[href]');
    if (!t) { return; }
    if (t.hasAttribute('data-mm-open')) {
      var p = document.getElementById(t.getAttribute('data-mm-open'));
      if (p) { e.preventDefault(); showPanel(p); }
    } else if (t.hasAttribute('data-mm-back')) {
      e.preventDefault();
      backToRoot();
    } else if (t.hasAttribute('data-mm-close')) {
      e.preventDefault();
      closeSheet();
    } else {
      followLink(t, e);
    }
  });

  /* ---- keyboard: Escape goes back / closes, Space opens a category, Tab stays in the panel --------- */
  document.addEventListener('keydown', function (e) {
    if (!isOpen) { return; }
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      if (panel()) { backToRoot(); } else { closeSheet(); }
      return;
    }
    var opener = closest(e.target, '[data-mm-open]');
    if (opener && (e.key === ' ' || e.key === 'Spacebar')) {
      e.preventDefault();
      opener.click();
      return;
    }
    if (e.key !== 'Tab') { return; }
    var scope = panel() || root();
    if (!scope) { return; }
    var items = scope.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]');
    if (!items.length) { return; }
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (!scope.contains(active)) { e.preventDefault(); focusEl(e.shiftKey ? last : first); return; }
    if (e.shiftKey && (active === first || active === scope)) { e.preventDefault(); focusEl(last); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); focusEl(first); }
  });

  /* ---- scroll (capture, since scroll does not bubble): keep the stuck shadows in sync ----------------- */
  var ticking = false;
  document.addEventListener('scroll', function (e) {
    var p = e.target && e.target.nodeType === 1 && e.target.classList.contains('mm-panel') ? e.target : null;
    if (!p || ticking) { return; }
    ticking = true;
    window.requestAnimationFrame(function () { ticking = false; updateStuck(p); });
  }, true);

  /* ---- a right-swipe on a level-2 panel goes back ------------------------------------------------------- */
  var touch = null;
  document.addEventListener('touchstart', function (e) {
    var p = panel();
    if (!p || e.touches.length !== 1 || !p.contains(e.target)) { touch = null; return; }
    touch = { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() };
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!touch || !panel() || !e.changedTouches.length) { touch = null; return; }
    var dx = e.changedTouches[0].clientX - touch.x;
    var dy = Math.abs(e.changedTouches[0].clientY - touch.y);
    var dt = Date.now() - touch.t;
    touch = null;
    if (dx > 70 && dy < 60 && dx > dy * 2 && dt < 700) { backToRoot(); }
  }, { passive: true });

  /* ---- viewport grew past the mobile breakpoint, or the theme editor re-rendered the section --------- */
  function onMedia(e) { if (!e.matches && isOpen) { closeSheet(); } }
  if (mql) {
    if (mql.addEventListener) { mql.addEventListener('change', onMedia); }
    else if (mql.addListener) { mql.addListener(onMedia); }
  }

  /* ---- quick links: rendered hidden by the "Mobile menu quick links" section, copied into the sheet ---- */
  function syncQuickLinks() {
    var s = sheet();
    var src = document.getElementById('mm-quick-source');
    var slot = s ? s.querySelector('.mm-quick') : null;
    if (!src || !slot) { return; }
    while (slot.firstChild) { slot.removeChild(slot.firstChild); }
    var links = src.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) { slot.appendChild(links[i].cloneNode(true)); }
    slot.hidden = !links.length;
  }

  function enhance() { // category rows are real links for no-JS; with JS they act as buttons
    syncQuickLinks();
    var s = sheet();
    if (!s) { return; }
    var rows = s.querySelectorAll('[data-mm-open]');
    for (var i = 0; i < rows.length; i++) {
      rows[i].setAttribute('role', 'button');
      rows[i].setAttribute('aria-controls', rows[i].getAttribute('data-mm-open'));
      rows[i].setAttribute('aria-expanded', 'false');
    }
  }
  enhance();
  document.addEventListener('shopify:section:load', function (e) { // theme editor re-rendered a section
    var s = sheet();
    if (s && e.target && e.target.contains && e.target.contains(s)) { // the mega menu itself: start over
      if (isOpen) { closeSheet(); }
      openPanelId = null;
    }
    enhance(); // any section: re-copy the quick links, re-mark the category rows
  });
})();
